import React from 'react';
import { Carousel, useCarousel } from '@yme/atoms/carousel';
import { CardForEvents } from '@yme/molecules/cards/card-for-events';
import { CARD_ITEM_SETTINGS, GAP_BETWEEN_ITEMS } from './constants';
export function WhatToReadNextCarousel(props) {
    const { cardProps, isRightToLeft } = props;
    const { activeItem, onClickPrevItem, onClickNextItem, counts, setCounts } = useCarousel();
    return (React.createElement(Carousel, { counts: counts, isRightToLeft: isRightToLeft, activeItem: activeItem, onClickPrevItem: onClickPrevItem, onClickNextItem: onClickNextItem, getterSize: GAP_BETWEEN_ITEMS, items: cardProps, ChildComponent: CardForEvents, setCounts: setCounts, carouselConfig: CARD_ITEM_SETTINGS, isDotsPanelVisible: true, dataTestId: "what-to-read-next-carousel" }));
}
WhatToReadNextCarousel.displayName = 'WhatToReadNextCarousel_AEMComponent';
